<template>
  <div class="content" style="background-color: white" >
    <div>
      <nav class="bar bar-nav">
        <a class="button button-link button-nav pull-left"  @click="gotolast()">
          <span class="icon icon-left"></span>返回
        </a>
      </nav>
    </div>
    <div>
    <div  style="margin-bottom: 10px;margin-top: 2.5rem" v-if="channels" >
      <div class="card demo-card-header-pic">
        <div valign="bottom" class="card-header color-white no-border no-padding">
          <img class='card-cover' :src="baseurl + channels.descUrl">
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <div class="card-content-inner">信号通路研究，是做基础科研接触最多的一个方面，不管是设计课题写基金还是发表文章，都需要对信号通路有一定的了解。常在文章里面见到各种各样的信号通路，比如经典的P53信号通路、NF-κB信号、Wnt信号通路等等。
           <br>
            现在吉凯基因将持续不断的推出各类经典通路的促销活动，免除您有做通路研究的决心而无经费支持的尴尬，为您的科研提供最有利的保障。赶紧点击详情了解一下！
          </div>
        </div>
      </div>
      <div style="margin-bottom: 3rem">


      <div  class="card" v-for="pro in channels.promotionList " >
        <div @click="gotoPro(pro)" style="margin-top: 1rem;margin-bottom: 4rem;background-color: #F7E7D8">
          <div style="text-align: left;font-size: x-large;margin-bottom: 0.5rem;margin-top: 0.5rem">
            {{pro.name}}
          </div>
          <div style="text-align: left;">
            {{pro.description}}
          </div>
          <div style="text-align: right;margin-bottom: 0.5rem">点击进入活动专场</div>
          <!--<div class="card-header">{{pro.name}}</div>-->
          <!--<div class="card-content">-->
            <!--<div class="list-block media-list">-->
              <!--<ul>-->
                <!--<li class="item-content">-->
                  <!--<div class="item-media">-->
                    <!--<img :src="baseurl + pro.imageUrl" width="80">-->
                  <!--</div>-->
                  <!--<div class="item-inner">-->
                    <!--<div class="item-title-row">-->
                      <!--<div class="item-title">{{pro.name}}</div>-->
                    <!--</div>-->
                    <!--<div class="item-subtitle">子标题</div>-->
                  <!--</div>-->
                <!--</li>-->
              <!--</ul>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div>-->
          <!--</div>-->
        </div>

      </div>
      </div>
    </div>
    <div >
      <div>
      </div>
    </div>


      <!--<div class="searchbar">-->
        <!--<a class="searchbar-cancel">取消</a>-->
        <!--<div class="search-input">-->
          <!--<label class="icon icon-search" for="search"></label>-->
          <!--<input type="search" id='search'  class="open-popup open-goods" data-popup=".popup-goods" placeholder='输入商品...' readonly unselectable="on"/>-->
        <!--</div>-->
      <!--</div>-->
    </div>



  </div>

</template>

<script>
//  import $ from 'jquery'
  import {mapGetters} from 'vuex'
  import emkt from '../../emkt.js'
  export default {
    mounted () {
      // console.log('mounted')
    },
    created () {
      this.fetchData()
    },
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/promotion/',
        channels: []
      }
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      // '$route': 'fetchData'
    },
    components: {
    },
    computed: {
      ...mapGetters([
        // ...
      ])
    },
    methods: {
      fetchData () {
        var channelList = emkt.getLocalStorage('EmktChannels')
        for (var i = 0; i < channelList.length; i++) {
          if (this.$route.query.promotionGroupGuid === channelList[i].promotionGroupGuid) {
            this.channels = channelList[i]
          }
        }
      },
      tolast () {
        this.$router.go(-1)
      },
      gotoPro (pro) {
        this.$router.push({name: 'ChannelDetails', query: {promotionGuid: pro.promotionGuid, imageUrl: pro.imageUrl}})
      },
      gotolast () {
        this.$router.push({name: 'home'})
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .button{
    color: #0a8ddf;
    border: 0rem;
    font-size: 1rem
  }
</style>



// WEBPACK FOOTER //
// Channel.vue?ff6e0c90